/* ==========================================================================
   Scroll Animations
   IntersectionObserver-based reveal animations for sections.
   Elements with [data-scroll-reveal] fade-in-up when entering viewport.
   ========================================================================== */

(function () {
  'use strict';

  var DEFAULTS = {
    threshold: 0.12,
    rootMargin: '0px 0px -60px 0px'
  };

  var ANIMATION_CLASS = 'is-revealed';

  /**
   * Initialize scroll reveal animations.
   * Looks for elements with [data-scroll-reveal] attribute.
   * Optional per-element delay via data-scroll-delay="100" (ms).
   * Optional stagger via data-scroll-stagger on parent (children
   * get sequential delays).
   */
  function initScrollAnimations() {
    if (typeof IntersectionObserver === 'undefined') {
      // Fallback: reveal everything immediately
      var els = document.querySelectorAll('[data-scroll-reveal]');
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add(ANIMATION_CLASS);
      }
      return;
    }

    // Respect prefers-reduced-motion
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery && motionQuery.matches) {
      var allEls = document.querySelectorAll('[data-scroll-reveal]');
      for (var j = 0; j < allEls.length; j++) {
        allEls[j].classList.add(ANIMATION_CLASS);
        allEls[j].style.transitionDuration = '0ms';
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-scroll-delay') || '0', 10);

        if (delay > 0) {
          setTimeout(function () {
            el.classList.add(ANIMATION_CLASS);
          }, delay);
        } else {
          el.classList.add(ANIMATION_CLASS);
        }

        observer.unobserve(el);
      });
    }, {
      threshold: DEFAULTS.threshold,
      rootMargin: DEFAULTS.rootMargin
    });

    // Observe all [data-scroll-reveal] elements
    var targets = document.querySelectorAll('[data-scroll-reveal]');
    targets.forEach(function (target) {
      observer.observe(target);
    });

    // Handle stagger containers: apply sequential delays to children
    var staggerContainers = document.querySelectorAll('[data-scroll-stagger]');
    staggerContainers.forEach(function (container) {
      var staggerMs = parseInt(container.getAttribute('data-scroll-stagger') || '100', 10);
      var children = container.querySelectorAll('[data-scroll-reveal]');
      children.forEach(function (child, index) {
        child.setAttribute('data-scroll-delay', String(index * staggerMs));
      });
    });

    // Re-observe after stagger delays are set
    staggerContainers.forEach(function (container) {
      var children = container.querySelectorAll('[data-scroll-reveal]');
      children.forEach(function (child) {
        observer.observe(child);
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  // Expose for dynamic content (e.g., AJAX-loaded sections)
  window.OnlyCookies = window.OnlyCookies || {};
  window.OnlyCookies.initScrollAnimations = initScrollAnimations;
})();
